<template>
  <v-card width="100%">
    <v-card-text>
      <canvas ref="canvas"></canvas>
    </v-card-text>
  </v-card>
</template>

<script>
import Chart from 'chart.js';

export default {
  name: 'MsrpChart',
  props: ['msrpGrouped'],
  data() {
    return {
      chart: null
    };
  },
  methods: {
    renderChart() {
      if (this.chart) {
        this.chart.destroy(); // Meglévő chart törlése
      }

      const labels = this.msrpGrouped.map(item => item.label);
      const expectedData = this.msrpGrouped.map(item => item.expectedMsrp);
      const msrpData = this.msrpGrouped.map(item => item.totalMsrp);

      const ctx = this.$refs.canvas.getContext('2d');
      this.chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels,
          datasets: [
            {
              label: 'Elvárt €',
              data: expectedData,
              borderColor: '#4CAF50',
              backgroundColor: 'rgba(76, 175, 80, 0.1)',
              fill: true,
              tension: 0.4
            },
            {
              label: 'MSRP €',
              data: msrpData,
              borderColor: '#2196F3',
              backgroundColor: 'rgba(33, 150, 243, 0.1)',
              fill: true,
              tension: 0.4
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true
            }
          }
        }
      });
    }
  },
  mounted() {
    this.renderChart();
  },
  watch: {
    msrpGrouped: {
      handler() {
        this.renderChart();
      },
      deep: true
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
};
</script>

<style scoped>
canvas {
  width: 100% !important;
  height: 300px !important;
}
</style>
